<template>
  <div>
    <v-container>
      <v-layout
        v-bind="orientation"
        align-center
        justify-space-around
      >
        <!-- start site type -->
        <v-flex xs3>
          <v-select
            v-model="campsiteType"
            :items="campsiteTypes"
            item-text="campsiteTypeWord"
            item-value="campsiteTypeID"
            prepend-icon="change_history"
          />
        </v-flex>
        <!-- end site type -->
        <!-- start campground select -->
        <v-flex xs3>
          <v-select
            v-model="campground"
            :items="campgrounds"
            item-text="campgroundName"
            item-value="campgroundID"
            prepend-icon="fa-map-marked-alt"
          />
        </v-flex>
        <!-- end camppground select -->
        <!-- start toggles -->
        <v-flex xs3>
          <v-layout>
            <v-switch
              v-model="accessible"
              prepend-icon="fa-wheelchair"
              color="green"
            />
            <v-switch
              v-model="campfire"
              prepend-icon="fa-fire"
              color="red"
            />
            <v-switch
              v-if="assertSetting('viewTableReserve', 1)"
              v-model="admin"
              prepend-icon="fa-lock"
              color="black"
            />
          </v-layout>
        </v-flex>
      </v-layout>
      <!-- end toggles -->
      <!-- start extra -->
      <v-layout justify-center>
        <v-checkbox
          v-model="showUnavailable"
          label="Show Unavailable Sites"
          type="checkbox"
          class="shrink mr-2"
        />
      </v-layout>
      <!-- end extra -->
      <!-- start view selector -->
      <v-layout
        v-if="assertSetting('viewTableReserve', 1)"
        justify-center
        class="mt-2"
      >
        <v-tabs v-model="view">
          <v-tab href="#list">
            <v-icon>fa-list</v-icon>
          </v-tab>
          <v-tab href="#table">
            <v-icon>fa-table</v-icon>
          </v-tab>
        </v-tabs>
      </v-layout>
      <!-- end view selector -->
    </v-container>
    <v-alert
      :value="true"
      dismissible
      type="warning"
    >
      <span
        v-html="settings.textCamping"
      />
    </v-alert>
  </div>
</template>
<script>
// import vuex mapping
import { mapFields } from 'vuex-map-fields'
import { mapGetters } from 'vuex'
// our new component
export default {
  computed: {
    ...mapFields({
      campsiteType: 'facilities.searchCriteria.campsiteType',
      campground: 'facilities.searchCriteria.campground',
      accessible: 'facilities.searchCriteria.accessible',
      campfire: 'facilities.searchCriteria.campfire',
      showUnavailable: 'facilities.searchCriteria.showUnavailable',
      admin: 'facilities.searchCriteria.admin',
      view: 'facilities.searchCriteria.view'
    }),
    ...mapGetters({
      availableCampsiteTypes: 'facilities/campsiteTypes',
      availableCampgrounds: 'facilities/campgrounds'
    }),
    campsiteTypes () { // append a default option for all
      let types = {
        campsiteTypeID: null,
        campsiteTypeWord: 'All Site Types'
      }
      return [types, ...this.availableCampsiteTypes] // new array
    },
    campgrounds () { // append a default option for all
      let types = {
        campgroundID: null,
        campgroundName: 'All Campgrounds'
      }
      return [types, ...this.availableCampgrounds] // new array
    },
    orientation () { // switches layout from row to column on small screens
      const binding = {}

      if (this.$vuetify.breakpoint.smAndDown) binding.column = true

      return binding
    }
  }
}
</script>
